import { Component, OnInit } from '@angular/core';
import {EnvironmentService} from 'bos-commons';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  constructor(public environmentService: EnvironmentService) {
  }

  ngOnInit(): void {
  }

  getFrameworkLogoUrl() {
    return this.environmentService.environment.backendBaseUrl + '/urls/logo';
  }

}
